import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { InspectionService } from 'src/app/core/services/inspection/inspection.service';
import { InspectorsService } from 'src/app/core/services/inspectors/inspectors.service';
import * as moment from 'moment';
import { OrderStatus } from 'src/app/models/enums/order-status.enum';
import { Store } from '@ngxs/store';
import { OrderState } from '../../state/order.state';
import { Observable } from 'rxjs';
import { UpdateOrderDetails } from '../../state/order-action';
import { OrderType } from 'src/app/models/enums/order-type.enum';
import { AdminOrdersService } from '../../services/orders/admin-orders.service';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { extractErrorMessage } from 'src/app/core/services/uitls/error.util';
import { AssigneeOption } from '../assignee-modal/assignee-modal.component';
import { map } from 'rxjs/operators';
import { ReProjectsService } from 'src/app/features/re-projects/services/re-projects.service';
import { CompanyServicesService } from 'src/app/features/companies/services/company-services/company-services.service';

@Component({
    selector: 'order-main-details',
    templateUrl: './order-main-details.component.html',
    styleUrls: ['./order-main-details.component.scss'],
    standalone: false
})
export class OrderMainDetailsComponent implements OnInit, OnDestroy {
  buildingTypes: any;
  inspectors: any[] = [];
  status: any;
  orderStatus: any;
  inspectionPeriods: any;
  Inspection_purpose: any;
  orderMainDetailsFormGroup: UntypedFormGroup;
  @Output() enableSave = new EventEmitter();
  minDate = new Date();
  disableDate: boolean = false;
  disableSelect: boolean = false;
  selectedPeriods = [];
  disableSave: boolean = false;
  @ViewChild('select') select: NgSelectComponent;
  @ViewChild('selectInsp') selectInsp: NgSelectComponent;
  @ViewChild('selectExperts') selectExperts: NgSelectComponent;
  @ViewChild('selectQc') selectQc: NgSelectComponent;
  @ViewChild('selectStatus') selectStatus: NgSelectComponent;
  params: any;
  page: number = 1;
  page_count: number = 0;
  timeout: any = null;
  acadamicMajor: any;
  dateLabel = ' تاريخ الفحص ';
  datePlaceholder = 'يرجى تحديد تاريخ الفحص ';
  mainOrdersList: any[] = [];
  clientGoals: any[] = [];
  propertyRelations: any[] = [];
  clientPropertyRelationName: string = '';

  private onScroll = (event: any) => {
    if (this.select?.isOpen || this.selectInsp?.isOpen || this.selectExperts?.isOpen || this.selectStatus?.isOpen || this.selectQc?.isOpen) {
      const isScrollingInScrollHost =
        (event.target.className as string)?.indexOf('ng-dropdown-panel-items') >
        -1;
      if (isScrollingInScrollHost) {
        return;
      }
      this.closeSelectPanel(this.select);
      this.closeSelectPanel(this.selectInsp);
      this.closeSelectPanel(this.selectExperts);
      this.closeSelectPanel(this.selectStatus);
      this.closeSelectPanel(this.selectQc);
    }
  };
  alertmsg: boolean = false;
  errorMessage: string;
  @Output() errorMsg = new EventEmitter();
  orderType: any;
  periodLabel: string = ' فترة الفحص';
  orderData: any;
  mainOrders: any[] = [];
  referenceNumberList: any[] = [];
  refrencePageCount: any;
  refrencePage: number;
  refrenceParams: { page: any; };
  selectedRefrenceNumber: any;
  qualityControls: any[] = [];
  inspectors_payload: { page: any; query: string; page_size: any };
  allExperts: any[] = [];
  pagination = {
    inspectors: { page: 1, page_count: 0 },
    qualityControls: { page: 1, page_count: 0 },
  };
  ordersExperts: any[] = [];
  availableExperts: any[] = [];
  deleteDialogRef: MatDialogRef<ConfirmationBoxComponent>;
  closeSelectPanel(select) {
    if (select && select.isOpen) {
      select.close();
    }
  }
  searchInput: string;
  assigneeError: string | null = null;
  orderDetails$: Observable<any>;
  serverError$: Observable<any>;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private inspectorService: InspectorsService,
    private InspectionService: InspectionService,
    private orderService: AdminOrdersService,
    private companyServices: CompanyServicesService,
    private reProjectsService: ReProjectsService,
    private store: Store,
    private dialog: MatDialog
  ) {
    this.orderDetails$ = this.store.select(OrderState.getOrderDetails);
    this.serverError$ = this.store.select(OrderState.getServerError);
  }

  ngOnInit(): void {
    this.createForm();
    this.createFormControls();
    this.orderDetails$.subscribe((data) => {
      this.setOrderDetails(data);
    });

    this.selectedPeriods = this.orderData.order_periods;
    this.orderType = this.orderData.order_type;
    this.orderStatus = this.orderData.status;
    this.getInspectors({ page: this.pagination.inspectors.page });
    this.getInspectionStatus();
    this.getClientGoals();
    this.getinspectionPeriods();
    this.getAcadamicMajor();
    this.getPropertyRelations();

    window.addEventListener('scroll', this.onScroll, true);

    if (this.orderType == OrderType.Visit) {
      this.setOrderVisit();
    }

    if ([OrderStatus.Completed, OrderStatus.Delivered, OrderStatus.Under_Inspectoring].includes(this.orderStatus)) {
      this.disableSave = true;
    }
  }

  setOrderDetails(data) {
    this.orderData = data;
    this.patchValues();
    this.disableDate = this.orderData.is_inspection_later;
    this.disableSelect = this.orderData.is_inspection_later;
    this.updateFrom();
  }

  setOrderVisit() {
    this.dateLabel = 'تاريخ الزيارة';
    this.periodLabel = 'فترة الزيارة';
    this.datePlaceholder = 'يرجى تحديد تاريخ الزيارة';
    this.setRequiredValidatorVal('inspector_academic_major');
  }

  createForm() {
    this.orderMainDetailsFormGroup = this.formBuilder.group({
      reference_number: [null],
      order_inspector: [null],
      order_experts: [[]],
      inspector_academic_major: [null],
      status: [null, Validators.required],
      order_date: [null, Validators.required],
      is_inspection_later: [false],
      order_periods: [null, Validators.required],
      linked_order: [null],
      notes: [null],
      client_goal: [null],
      qc_auditor:[null],
      internal_notes: [null],
      linked_real_estate_project_developer: [null],
      linked_real_estate_project: [null],
    });
  }

  createFormControls() {
    return this.orderMainDetailsFormGroup.controls;
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.onScroll, true);
  }

  searchtext(
    listName: "inspectors" | "qualityControls",
    fetchFn: (params: any) => void,
    searchTerm: string,
    multiple: boolean = false
  ) {

    if (!multiple) {
      this[listName] = [];
    }

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      let params: any;

      if (searchTerm && searchTerm.trim() !== "") {
        params = { full_name: searchTerm, ordering: "full_name" };
      } else {
        params = { page: 1 };
      }

    fetchFn(params);
    }, 600);
  }

  resetSearch(
    listName: "inspectors" | "qualityControls",
    fetchFn: (params: any) => void,
    multiple: boolean = false
  ) {

    if (!multiple) {
      this[listName] = [];
    }

    this.pagination[listName].page = 1;
    const params = { page: 1 };
    fetchFn(params);
  }

  onScrollPagination(
    listName: keyof typeof this.pagination,
    fetchFn: (params: any) => void,
    extraParams: any = {}
  ) {
    const state = this.pagination[listName];
    if (state.page < state.page_count) {
      state.page++;
      const params = { page: state.page, ...extraParams};
      fetchFn(params);
    }
  }

  inspectorData(inspector) {
    if (inspector) {
      let inspectorData = this.inspectors.find((item) => item.id == inspector);
      this.orderMainDetailsFormGroup
        .get('inspector_academic_major')
        .setValue(inspectorData.academic_major);
      this.updateAvailableExperts();
    }
  }

  setInitData( source: any, target: { id: number; full_name: string }[]) {
    if (source?.pk && target) {
      target.length = 0;
      target.push({
        id: source.pk,
        full_name: source.full_name,
      });
    }
  }

  patchValues() {
    this.setInitData(
      this.orderData?.order_details?.order_inspector,
      this.inspectors
    );

    this.setInitData(
      this.orderData?.order_details?.qc_auditor,
      this.qualityControls
    );
    if (this.orderData.linked_order) {
      this.referenceNumberList = [];
      let refrenceObj = {
        id: this.orderData.linked_order.id,
        reference_number: this.orderData.linked_order.reference_number,
      };
      this.referenceNumberList.push(refrenceObj);
      this.selectedRefrenceNumber = this.orderData?.linked_order?.id;
    }
    +
    this.orderMainDetailsFormGroup.patchValue({
      reference_number: this.orderData.reference_number,
      inspector_academic_major: this.orderData.inspector_academic_major,
      order_inspector: this.orderData?.order_details?.order_inspector
        ? this.orderData.order_details.order_inspector.pk
        : null,
      status: this.orderData.status,
      order_date: moment(this.orderData.order_date),
      is_inspection_later: this.orderData.is_inspection_later,
      order_periods: this.orderData.order_periods,
      notes: this.orderData.notes,
      internal_notes: this.orderData.internal_notes,
      linked_order: this.orderData?.linked_order?.id,
      client_goal: this.orderData?.client_goal,
      qc_auditor: this.orderData?.qc_auditor,
      linked_real_estate_project_developer: this.orderData?.linked_real_estate_project_developer?.id,
      linked_real_estate_project: this.orderData?.linked_real_estate_project?.id,
    });
    this.resolvePropertyRelationName();
    if(this.orderData.order_experts && this.orderData.order_experts.length > 0) {
      this.patchOrderExperts();
    }
  }

  patchOrderExperts() {
    this.ordersExperts = this.orderData?.order_experts.filter(expert => expert?.user &&!expert?.is_primary);
    const expertIds = this.ordersExperts.map(expert => expert.user);
    this.orderMainDetailsFormGroup.patchValue({
      order_experts: expertIds
    });
    this.updateAvailableExperts();
  }

  setOrderExperts(event) {
    if (!event?.id) {
      return;
    }
    
    const currentExperts = this.ordersExperts || [];
    
    if (!currentExperts.includes(event?.id)) {
      this.inspectorService.postAdditionalExpert({ order: this.orderData.id, user: event?.id }).subscribe((data) => {
        this.ordersExperts.push(data[0]);
        this.orderData?.order_experts.push(data[0]);
        this.patchOrderExperts();
        this.updateAvailableExperts();
      }, error => {
        this.errorMsg.emit({
          message: extractErrorMessage(error) || 'حدث خطأ أثناء إضافة الخبير.',
          imgSuccess: false,
        });
      });
    }
    
    setTimeout(() => {
      if (this.selectExperts) {
        this.selectExperts.clearModel();
      }
    }, 0);
  }

  updateAvailableExperts() {
    const selectedExperts = this.ordersExperts?.map(expert => expert.user) || [];
    const primaryInspector = this.orderMainDetailsFormGroup.get('order_inspector')?.value;
    
    this.availableExperts = this.inspectors.filter(inspector => 
      !selectedExperts.includes(inspector.id) && inspector.id !== primaryInspector
    );
  }

  removeOrderExpert(expert, index) {
    this.showDeleteConfirmationBox(expert, index);
  }

  showDeleteConfirmationBox(expert, index) {
    this.deleteDialogRef = this.dialog.open(ConfirmationBoxComponent, {
      data: {
        id: expert.id,
        index,
        message: `هل أنت متأكد من حذف ${expert.expert_name}؟`
      }
    });

    this.deleteDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.inspectorService.deleteAdditionalExpert(expert.id).subscribe(() => {
          this.ordersExperts = this.ordersExperts.filter(e => e.id !== expert.id);
          this.orderData?.order_experts.splice(this.orderData.order_experts.findIndex(e => e.id === expert.id), 1);
          this.patchOrderExperts();
          this.updateAvailableExperts();
        });
      }
    });
  }

  handleBackendError(error) {
    try {
    } catch { }
  }

  getInspection() {
    this.InspectionService.getInspectionPurpose().subscribe(
      (data) => {
        this.Inspection_purpose = data;
      },
      (error) => {
        this.handleBackendError(error);
      }
    );
  }

  getInspectors(params) {
    this.inspectorService.getAvailableInspectors(params).subscribe(
      (data) => {
        const newInspectors = data.results.filter(
          newItem => !this.inspectors.some(existing => existing.id === newItem.id)
        );
        this.inspectors = [...this.inspectors, ...newInspectors];
        this.pagination.inspectors.page_count = data.pages_count;
        this.updateAvailableExperts();
      },
      (error) => {
        this.handleBackendError(error);
      }
    );
  }

   getAvaliableQc(params) {
    this.inspectorService.getAvailableQualityControl(params).subscribe(
      (data) => {
        const newQualityControls = data.results.filter(
          newItem => !this.qualityControls.some(existing => existing.id === newItem.id)
        );
        this.qualityControls = [...this.qualityControls, ...newQualityControls];
        this.pagination.qualityControls.page_count = data.pages_count;
      },
      (error) => {
        this.handleBackendError(error);
      }
    );
  }

  getClientGoals() {
    this.orderService.getClientGoals().subscribe((data) => {
      this.clientGoals = data;
    });
  }

  getPropertyRelations() {
    this.orderService.getPropertyRelations().subscribe({
      next: (data) => {
        this.propertyRelations = data?.data || [];
        this.resolvePropertyRelationName();
      },
      error: () => {
        this.propertyRelations = [];
      },
    });
  }

  resolvePropertyRelationName() {
    const id = this.orderData?.client_property_relation;
    if (id && this.propertyRelations.length) {
      const match = this.propertyRelations.find(r => r.id === id);
      this.clientPropertyRelationName = match ? match.name : '';
    }
  }

  getInspectionStatus() {
    this.InspectionService.getInspectionStatus().subscribe(
      (data) => {
        this.status = data;
      },
      (error) => {
        this.handleBackendError(error);
      }
    );
  }

  getinspectionPeriods() {
    this.InspectionService.getinspectionPeriods().subscribe(
      (data) => {
        this.inspectionPeriods = data;
      },
      (error) => {
        this.handleBackendError(error);
      }
    );
  }

  setOrderPeriods(event, enableSave) {
    this.orderMainDetailsFormGroup.controls.order_periods.patchValue([
      ...event,
    ]);
  }

  updateFrom() {
    if (this.disableDate) {
      this.changeFormControlValidators('order_date', null);
      this.selectedPeriods = [];
      this.changeFormControlValidators('order_periods', this.selectedPeriods);
    } else {
      this.setRequiredValidatorVal('order_date');
      this.setRequiredValidatorVal('order_date');
      let orderDateVal = this.orderData.order_date
        ? moment(this.orderData.order_date)
        : null;
      this.orderMainDetailsFormGroup.controls.order_date.setValue(orderDateVal);
      this.selectedPeriods = this.orderData.order_periods;
      this.setOrderPeriods(this.orderData.order_periods, false);
    }
  }

  changeFormControlValidators(formControl, newVal) {
    this.orderMainDetailsFormGroup.controls[formControl].setValue(newVal);
    this.orderMainDetailsFormGroup.controls[formControl].clearValidators();
    this.orderMainDetailsFormGroup.controls[
      formControl
    ].updateValueAndValidity();
  }

  setRequiredValidatorVal(formControl) {
    this.orderMainDetailsFormGroup.controls[formControl].setValidators(
      Validators.required
    );
    this.orderMainDetailsFormGroup.controls[
      formControl
    ].updateValueAndValidity();
  }

  toggleDisableDate(event) {
    this.disableDate = event.target.checked;
    this.disableSelect = event.target.checked;
    this.updateFrom();
  }

  save(event) {
    this.alertmsg = false;
    let orderUpdated = {};
    orderUpdated = this.orderMainDetailsFormGroup.value;
    if (this.orderMainDetailsFormGroup.get('order_date').value) {
      let formatedDate: any = moment(
        this.orderMainDetailsFormGroup.get('order_date').value
      );
      formatedDate = formatedDate.format('YYYY-MM-DD');
      orderUpdated['order_date'] = formatedDate;
    }
    if (
      this.orderMainDetailsFormGroup.status == 'INVALID' &&
      this.orderMainDetailsFormGroup.get('status').value != 8
    ) {
      this.alertmsg = true;
      this.errorMessage = 'يوجد خطأ في بعض البيانات';
      if (
        !this.orderMainDetailsFormGroup.controls.is_inspection_later.value &&
        this.orderMainDetailsFormGroup.controls.order_periods.value.length == 0
      ) {
        document.querySelector('#order_periods').classList.add('ng-invalid');
      }
      let fields = document.querySelectorAll(
        'ng-select.ng-invalid , mat-form-field.ng-invalid'
      );
      fields.forEach((field) => {
        field.parentElement.classList.add('invalid-field');
      });
      return;
    }
    this.disableSave = true;
    this.store.dispatch(
      new UpdateOrderDetails({ orderId: +this.orderData?.order_details.id, order: orderUpdated, buttonId: event.buttonId })
    ).subscribe(() => {
      this.disableSave = false;
      this.alertmsg = false;
      this.showConfirmationModal();
    });
    this.serverError$.subscribe(error => {
      if (error) {
        this.alertmsg = true;
        this.errorMessage = Object.values(error)[0].toString();
      }
    });
  }

  getAcadamicMajor() {
    this.inspectorService.getAcadamicMajor().subscribe((data) => {
      this.acadamicMajor = data;
    });
  }

  showConfirmationModal() {
    this.errorMsg.emit({
      message: 'تم تحديث البيانات بنجاح.',
      imgSuccess: true,
    });
  }

  hideErrorMSG() {
    this.alertmsg = false;
  }

  getRefrenceNumberByParams(params) {
    if (params.clearList) {
      this.referenceNumberList = [];
      this.mainOrders = []
      this.orderMainDetailsFormGroup.get('linked_order').setValue(null);
    }
    this.getReferenceNumberOrders(params.params);
  }

  setRefrenceData(linked_order) {
    this.orderMainDetailsFormGroup.get('linked_order').setValue(linked_order?.id);
  }

  getReferenceNumberOrders(params) {
    this.orderService.getRefrenceNumbers(params).subscribe(
      (data) => {
        this.mainOrders.push(...data.results);
        this.referenceNumberList = [...this.mainOrders];
        this.refrencePageCount = data.pages_count;
      },
      (error) => {
        try {
        } catch {}
      }
    );
  }

  // Data source providers for assignee modals
  getCompaniesDataSource() {
    return (params: { page: number; searchTerm?: string }) => {
      const apiParams: any = { page: params.page, page_size: 20 };
      if (params.searchTerm) {
        apiParams.query = params.searchTerm;
      }
      
      return this.companyServices.getCompaniesList(apiParams).pipe(
        map(response => ({
          results: response.results.map(company => ({
            id: company.pk,
            name: company.name_arabic
          })),
          pages_count: response.pages_count
        }))
      );
    };
  }

  getProjectsDataSource() {
    return () => {
      const companyId = this.orderMainDetailsFormGroup.get('linked_real_estate_project_developer')?.value;
      return this.reProjectsService.getCompanyREProjects(companyId).pipe(
        map(response => ({
          results: response.data.map(project => ({
            id: project.id,
            name: project.name_ar
          })),
          pages_count: response.meta?.pagination?.pages_count || 1
        }))
      );
    };
  }

  // Assignee handlers
  onCompanyAssigned(assignee: { id: number; name: string }) {
    if (assignee?.id && assignee?.id !== this.orderData?.linked_real_estate_project_developer?.id) {
      this.resetProjectSelection();
      this.assigneeError = 'يجب إسناد المشروع حتي يتم حفظ البيانات';
    }
    this.orderData.linked_real_estate_project_developer = {
      id: assignee.id,
      name: assignee.name
    };
    this.orderMainDetailsFormGroup.patchValue({
      linked_real_estate_project_developer: assignee.id
    });
  }

  resetProjectSelection() {
    this.orderData.linked_real_estate_project = null;
    this.orderMainDetailsFormGroup.patchValue({
      linked_real_estate_project: null
    });
  }

  onCompanyUnlinked() {    
    this.orderData.linked_real_estate_project_developer = null;
    this.orderMainDetailsFormGroup.patchValue({
      linked_real_estate_project_developer: null
    });

    this.resetProjectSelection();
  }

  onProjectAssigned(assignee: { id: number; name: string }) {    
    
    this.orderData.linked_real_estate_project = {
      id: assignee.id,
      name: assignee.name
    };
    this.orderMainDetailsFormGroup.patchValue({
      linked_real_estate_project: assignee.id
    });
    this.assigneeError = null;
  }

  onProjectUnlinked() {    
    this.orderData.linked_real_estate_project = null;
    this.orderMainDetailsFormGroup.patchValue({
      linked_real_estate_project: null
    });
  }
}
